<template>
  <div id="profile_modal_user" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
        </div>
        <div class="modal-body">
          <div class="row" v-if="getLoading">
            <vue-spinner></vue-spinner>
          </div>
          <div class="row" v-else>
            <div class="col-md-3">
              <form action="#" role="form" enctype="multipart/form-data">
                <div class="portlet light avatar-box">
                  <div class="portlet-title tabbable-line">
                    <div class="caption caption-md">
                      <i class="icon-globe theme-font hide"></i>
                      <span class="caption-subject bold uppercase">{{ user.fullName }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="fileinput fileinput-new" data-provides="fileinput">
                    <div class="fileinput-new thumbnail">
                      <avatar v-bind:username="(user.fullName != null) ? user.fullName : 'C M'"
                              v-bind:src="(user.avatar == null) ? undefined : user.avatar" :size="140" :rounded="true"
                              color="#d09f23"
                              backgroundColor="#eef1f5"></avatar>
                    </div>
                  </div>
                  <a class="btn green" @click="toggleShow">Upload Image</a>
                  <vue-image-crop-upload field="img"
                                         @crop-success="cropSuccess"
                                         v-model="show"
                                         :noRotate="false"
                                         :width="300"
                                         :height="300"
                                         lang-type="en"
                                         img-format="png"/>
                  <button class="btn default" @click.prevent="updateAvatarBase(null)">Remove</button>

                </div>
              </form>
            </div>
            <div class="col-md-9">
              <div class="portlet light">
                <div class="portlet-title tabbable-line">
                  <div class="caption caption-md">
                    <i class="icon-globe theme-font hide"></i>
                    <span class="caption-subject bold uppercase">Profile Account</span>
                  </div>
                  <ul class="nav nav-tabs">
                    <li class="active">
                      <a href="#tab_1_1_user" data-toggle="tab" aria-expanded="true">My Profile</a>
                    </li>
                    <li class="" v-if="false">
                      <a href="#tab_1_3_user" data-toggle="tab" aria-expanded="false">Change Password</a>
                    </li>
                    <li class="">
                      <a href="#tab_1_4_user" data-toggle="tab" aria-expanded="false">User Access</a>
                    </li>
                  </ul>
                </div>
                <div class="portlet-body">
                  <div class="tab-content">
                    <!-- PERSONAL INFO TAB -->
                    <div class="tab-pane active" id="tab_1_1_user">
                      <form role="form" data-vv-scope="profile-form-modal" action="#">
                        <div class="form-group" :class="{ 'has-error': errors.has('profile-form-modal.Full Name') }">
                          <label class="control-label">Full Name</label>
                          <input type="text" placeholder="" class="form-control" name="Full Name"
                                 v-model="user.fullName"
                                 v-validate="'required'">
                          <span v-show="errors.has('profile-form-modal.Full Name')" class="help-block">{{ errors.first('profile-form-modal.Full Name') }}</span>
                        </div>
                        <div class="form-group">
                          <label class="control-label">Email Address</label>
                          <input type="text" placeholder="" class="form-control" v-model="user.email"
                                 :disabled="currentUser.access < 5">
                        </div>
                        <div class="form-group" :class="{ 'has-error': errors.has('profile-form-modal.Job Title') }">
                          <label class="control-label">Job Title</label>
                          <input type="text" placeholder="" class="form-control" name="Job Title"
                                 v-model="user.jobTitle"
                                 v-validate="'required'">
                          <span v-show="errors.has('profile-form-modal.Job Title')" class="help-block">{{ errors.first('profile-form-modal.Job Title') }}</span>
                        </div>
                        <div class="form-group"
                             :class="{ 'has-error': errors.has('profile-form-modal.Primary Phone') }">
                          <label class="control-label">Primary Phone</label>
                          <input type="text" placeholder="" class="form-control" name="Primary Phone"
                                 v-model="user.primaryPhone" v-validate="'required'">
                          <span v-show="errors.has('profile-form-modal.Primary Phone')" class="help-block">{{ errors.first('profile-form-modal.Primary Phone') }}</span>
                        </div>
                        <div class="margiv-top-10">
                          <button class="btn green mt-ladda-btn ladda-button updateInfoAction_user"
                                  data-style="expand-left"
                                  @click.prevent="updateUserInfo">
                            <span class="ladda-label">Save Changes</span>
                          </button>
                          <button type="button" data-dismiss="modal" aria-hidden="true" class="btn default"> Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                    <!-- END PERSONAL INFO TAB -->
                    <!-- CHANGE PASSWORD TAB -->
                    <div class="tab-pane" v-if="false" id="tab_1_3_user">
                      <form action="#" data-vv-scope="password-form" @submit.prevent="changePassword">
                        <div class="form-group" :class="{ 'has-error': errors.has('password-form.current password') }">
                          <label class="control-label">Current Password</label>
                          <input type="password" class="form-control" name="current password"
                                 v-model="user.currentPassword"
                                 v-validate="'required'" :class="{'input': true }">
                          <span v-show="errors.has('password-form.current password')" class="help-block">{{ errors.first('password-form.current password') }}</span>
                        </div>
                        <div class="form-group" :class="{ 'has-error': errors.has('password-form.new password') }">
                          <label class="control-label">New Password</label>
                          <input type="password" class="form-control" v-model="user.newPassword" id="newPass_user"
                                 name="new password"
                                 v-validate="{required:true, min:4, max:12, regex: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])[0-9A-Za-z!@#$%]{4,12}$' }"
                                 :class="{'input': true }">
                          <span v-show="errors.has('password-form.new password')" class="help-block">{{ errors.first('password-form.new password') }}</span>
                        </div>
                        <div class="form-group"
                             :class="{ 'has-error': errors.has('password-form.confirm new password') }">
                          <label class="control-label">Confirm New Password</label>
                          <input type="password" class="form-control" v-model="user.confirmNewPassword"
                                 name="confirm new password" v-validate="{required: true, is: user.newPassword}"
                                 :class="{'input': true }" ref="new password">
                          <span v-show="errors.has('password-form.confirm new password')" class="help-block">{{ errors.first('password-form.confirm new password') }}</span>
                        </div>
                        <div class="margin-top-10">
                          <button class="btn green mt-ladda-btn ladda-button changePasswordAction_user"
                                  data-style="expand-left" type="submit">
                            <span class="ladda-label">Change Password</span>
                          </button>
                          <button type="button" data-dismiss="modal" aria-hidden="true" class="btn default"> Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                    <!-- END CHANGE PASSWORD TAB -->
                    <!-- PRIVACY SETTINGS TAB -->
                    <div class="tab-pane" id="tab_1_4_user">
                      <form action="#">
                        <table class="table table-light table-hover">
                          <tbody>
                          <tr v-if="false">
                            <td><b>Referral User</b> - This access allows users to submit a new referral lead to a
                              CaseMGR Account and track submissions.
                            </td>
                            <td>
                              <div class="mt-radio-inline">
                                <label class="mt-radio">
                                  <input type="radio" value="1" name="userradio-1" :checked="user.access === 1" v-model="user.access"> Yes
                                  <span></span>
                                </label>
                                <label class="mt-radio">
                                  <input type="radio" value="0" name="userradio-1" class="userradio-no" :checked="user.access !== 1" disabled="disabled"> No
                                  <span></span>
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><b>Volunteer</b> - This access allows users to view the Participant Dashboard, and enter and view Participant forms.</td>
                            <td>
                              <div class="mt-radio-inline">
                                <label class="mt-radio">
                                  <input type="radio" value="2" name="userradio-2" :checked="user.access === 2" v-model="user.access"> Yes
                                  <span></span>
                                </label>
                                <label class="mt-radio">
                                  <input type="radio" value="0" name="userradio-2" class="userradio-no" :checked="user.access !== 2" disabled="disabled"> No
                                  <span></span>
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><b>Case Manager</b> - This access includes Volunteer privileges and allows users to add
                              new participants and assignments, enter, edit, delete and view forms, generate reports,
                              and modify the Participant’s Assignment page.
                            </td>
                            <td>
                              <div class="mt-radio-inline">
                                <label class="mt-radio">
                                  <input type="radio" value="3" name="userradio-3" :checked="user.access === 3" v-model="user.access"> Yes
                                  <span></span>
                                </label>
                                <label class="mt-radio">
                                  <input type="radio" value="0" name="userradio-3" class="userradio-no" :checked="user.access !== 3" disabled="disabled"> No
                                  <span></span>
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><b>Supervisor</b> - This access includes Case Manager privileges and allows users to view a Caseload Summary for each Case Manager, view the Referral Dashboard, and create, edit, generate, and publish reports.</td>
                            <td>
                              <div class="mt-radio-inline">
                                <label class="mt-radio">
                                  <input type="radio" value="4" name="userradio-4" :checked="user.access === 4" v-model="user.access"> Yes
                                  <span></span>
                                </label>
                                <label class="mt-radio">
                                  <input type="radio" value="0" name="userradio-4" class="userradio-no" :checked="user.access !== 4" disabled="disabled"> No
                                  <span></span>
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td><b>Program Administrator</b> - This access includes Supervisor privileges and allows
                              users to access Administrative Settings, manage users, import data, and create, edit,
                              generate and publish forms.
                            </td>
                            <td>
                              <div class="mt-radio-inline">
                                <label class="mt-radio">
                                  <input type="radio" value="5" name="userradio-5" :checked="user.access === 5" v-model="user.access"> Yes
                                  <span></span>
                                </label>
                                <label class="mt-radio">
                                  <input type="radio" value="0" name="userradio-5" class="userradio-no" :checked="user.access !== 5" disabled="disabled"> No
                                  <span></span>
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="currentUser.access > 5">
                            <td><b>System Administrator</b> - This access includes Program Administrator privileges and
                              allows users to access all accounts and functionality.
                            </td>
                            <td>
                              <div class="mt-radio-inline">
                                <label class="mt-radio">
                                  <input type="radio" value="6" name="userradio-6" :checked="user.access === 6" v-model="user.access"> Yes
                                  <span></span>
                                </label>
                                <label class="mt-radio">
                                  <input type="radio" value="0" name="userradio-6" class="userradio-no" :checked="user.access !== 6" disabled="disabled"> No
                                  <span></span>
                                </label>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <!--end profile-settings-->
                        <div class="margin-top-10">
                          <button class="btn green mt-ladda-btn ladda-button updateAccessAction_user"
                                  data-style="expand-left" type="submit" @click.prevent="changeAccess">
                            <span class="ladda-label">Save Changes</span>
                          </button>
                          <button type="button" data-dismiss="modal" aria-hidden="true" class="btn default"> Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                    <!-- END PRIVACY SETTINGS TAB -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import VueImageCropUpload from 'vue-image-crop-upload';
  import {mapGetters, mapActions} from 'vuex';
  import Avatar from '@/components/menu/Avatar';
  import Spinner from '@/components/Spinner';
  export default {

    data() {
      return {
        show: false,
        imgDataUrl: '',
        picked: 2
      }
    },
    components: {
      Avatar,
      VueImageCropUpload,
      'vue-spinner': Spinner
    },
    inject: {
      $validator: '$validator'
    },
    computed: {
      ...mapGetters({
        currentUser: 'getUser',
        account: 'account',
        user: 'getUserProfile',
        getLoading: 'getUserLoading'
      }),
    },
    methods: {
      ...mapActions({
        editUser: 'EDIT_USER_ACTION',
        editPassword: 'EDIT_USER_PASSWORD_ACTION',
        editAvatar: 'EDIT_USER_AVATAR_ACTION',
        editAccess: 'EDIT_USER_ACCESS_ACTION',
      }),
      cropSuccess(imgDataUrl, field){
        this.imgDataUrl = imgDataUrl;
        this.updateAvatarBase(imgDataUrl);
      },
      toggleShow() {
        this.show = !this.show;
      },
      updateUserInfo() {
        this.$validator.validateAll('profile-form-modal').then((result) => {
          if (result) {
            const context = Ladda.create(document.querySelector('.updateInfoAction_user'));
            this.editUser(context);
          }
        });
      },
      getName(str) {
        var arr = str.split(' ');
        if (arr.length === 1) {
          return arr[0];
        }
        return arr.slice(0, -1).join(' ');
      },
      getLastName(str) {
        var arr = str.split(' ');
        if (arr.length === 1) {
          return "";
        }
        return arr.slice(-1).join(' ');
      },
      updateAvatarBase(file) {
        this.editAvatar(file);
      },
      changePassword(){
        this.$validator.validateAll('password-form').then((result) => {
          if (result) {
            const context = Ladda.create(document.querySelector('.changePasswordAction_user'));
            this.editPassword(context);
          }
        });
      },
      changeAccess() {
        const context = Ladda.create(document.querySelector('.updateAccessAction_user'));
        this.editAccess({context, account_id: this.account.id});
      }
    },
    watch: {
      'user.access': function () {
        $("#profile_modal_user input.userradio-no").not($("input[name='userradio-" + this.user.access + "']")).prop("checked", true);
      }
    }
  }
</script>
<style scoped>
  .portlet.light {
    padding: 0px;
  }

  .avatar-box .portlet-title {
    min-height: 49px;
  }

  @media (min-width: 768px) {
    .mt-radio-inline {
      min-width: 130px;
    }
  }
</style>



// WEBPACK FOOTER //
// UserProfile.vue?715337df